import { Tag } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { Autocomplete } from '../../../../common/components/autocomplete';
import { IAppState, Dispatch } from '../../../../common/state';
import { EPropertyType } from '../../../../json_query';
import { PropertyTypeName } from '../../../../types/commercial';
import { propertyTypeAdded, propertyTypeRemoved } from '../../../state/advanced/property_type';
import { InlineParam, Row } from '../markup';

const style = require('./property_type.css');

interface IPropertyTypeProps {
  propertyTypes: EPropertyType[];
  onPropertyTypeAdded(value: EPropertyType): void;
  onPropertyTypeRemoved(value: EPropertyType): void;
}

const propertyType: React.StatelessComponent<IPropertyTypeProps> = ({
  propertyTypes,
  onPropertyTypeAdded,
  onPropertyTypeRemoved,
}) => (
  <Row title="Тип недвижимости">
    <InlineParam>
      <div className={style['input']}>
        <Autocomplete
          placeholder="Выберите тип недвижимости"
          suggestions={Array.from(PropertyTypeName)
            .filter(([key, value]) => !propertyTypes.includes(key))
            .map(([key, value]) => ({
              label: value,
              value: key,
            }))}
          onSelect={(suggestion: { label: string; value: EPropertyType }) => onPropertyTypeAdded(suggestion.value)}
        />
      </div>
      {propertyTypes.length > 0 && (
        <div>
          {propertyTypes.map(type => (
            <Tag
              key={`propertyType-${type}`}
              tagStyles={style['tag']}
              onDeleteClick={() => onPropertyTypeRemoved(type)}
            >
              {PropertyTypeName.get(type)}
            </Tag>
          ))}
        </div>
      )}
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    propertyTypes: (state.filters.jsonQuery.property_type && state.filters.jsonQuery.property_type.value) || [],
  }),
  (dispatch: Dispatch) => ({
    onPropertyTypeAdded: (value: EPropertyType) => {
      dispatch(propertyTypeAdded(value));
    },
    onPropertyTypeRemoved: (value: EPropertyType) => {
      dispatch(propertyTypeRemoved(value));
    },
  }),
)(propertyType);
